'use client';

import Image from 'next/image';

import { useTrackEventAmplitude } from '../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../design-system/components/form/button/Button';
import { Ratio, RATIO } from '../../../../../design-system/components/ratio/Ratio';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { OneImageAndTextBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';

import style from './OneImageAndTextBlockSlice.module.css';

export type OneImageAndTextBlockSliceProps = OneImageAndTextBlockSliceType;

export function OneImageAndTextBlockSlice({
    version,
    picture,
    text,
    ctaLabel,
    ctaLink,
    target,
    title,
    sliceIndex,
}: OneImageAndTextBlockSliceProps & { sliceIndex?: number }) {
    const { trackEvent } = useTrackEventAmplitude();

    return (
        <div className={style.wrapper}>
            {picture?.url ? (
                <div className={style.imageContainer}>
                    <Ratio ratio={RATIO['16/9']}>
                        <Image
                            className={style.image}
                            alt={picture.alt}
                            src={picture.url}
                            unoptimized
                            fill
                            loading="lazy"
                        />
                    </Ratio>
                    <div className={style.title}>
                        <Typography as="h2" scale="secondary-m-bold">
                            {title}
                        </Typography>
                    </div>
                </div>
            ) : null}
            <Typography as="div" scale="primary-s-regular" className={style.text}>
                {text}
            </Typography>
            {ctaLabel && ctaLink?.url ? (
                <div>
                    <Button
                        priority="text"
                        reversed={version === 'green'}
                        href={ctaLink?.url}
                        target={target || undefined}
                        onClick={() =>
                            trackEvent((ampli, defaultProperties) => {
                                ampli.imageTextBlockClicked({
                                    ...defaultProperties,
                                    card_number: 1,
                                    block_index: sliceIndex ? sliceIndex + 1 : 0,
                                    card_title: title ?? '',
                                });
                            })
                        }
                    >
                        {ctaLabel}
                    </Button>
                </div>
            ) : null}
        </div>
    );
}
